import type { DictionaryType } from 'types/story';
import { getText } from 'utils/dictionary';
import { DEFAULT_MEDIA_QUERY_PLATFORMS, COMPONENT_STATES, COMPONENT_TYPE as TYPE } from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Login/SMSLogin/SMSLogin';

type Props = {
	dictionary?: DictionaryType;
};

export const SMS_LOGIN = ({ dictionary = {} }: Props = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.SMS_LOGIN;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: SMS_LOGIN.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, SMS_LOGIN.displayName),
					},
					componentProps: {
						other: {},
						styles: {},
					},
				},
				children: {
					[COMPONENT_STATES.DEFAULT]: {
						[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: getText(dictionary, type, 'label'),
					},
				},
			};
		},
	};
};

SMS_LOGIN.displayName = 'SMS login';
